<template>
  <v-container fluid grid-list-md>
    <v-toolbar class="elevation-5 mb-0" style="z-index: 1">
      <v-btn icon @click="$router.go(-1)">
        <v-icon>arrow_back</v-icon>
      </v-btn>
      <v-toolbar-title v-if="$route.params.article_id">{{ form.name }}</v-toolbar-title>
      <v-toolbar-title v-else>New article</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn class="my-0" color="success" @click="save">save</v-btn>
    </v-toolbar>
    <progress-bar></progress-bar>
    <v-tabs class="elevation-1 mb-3" color="info" v-model="tabs" dark grow slider-color="#fff">
      <v-tab ripple>Main info</v-tab>
      <v-tab ripple>Participants</v-tab>
    </v-tabs>
    <v-tabs-items :touchless="true" v-model="tabs" class="transparent elevation-0">
      <v-tab-item>
        <v-layout row wrap>
          <v-flex xs12 sm3>
            <v-card>
              <v-card-text>
                <div class='sl_form_title'>
                  <h3>Information</h3>
                </div>
                <v-divider class='my-2'></v-divider>
                <v-text-field v-model="form.name" :error-messages="errorMessages('name')"
                              label="Title"></v-text-field>
                <v-select label="Parent article" :error-messages="errorMessages('parent_id')" :items="articles"
                          v-model="form.parent_id" item-text="name" item-value="id"
                          hint="Leave blank for the first level article" persistent-hint class="mb-4"></v-select>
                <v-select
                    label="Instance"
                    :items="user.instanceUsers"
                    item-text="instance.name"
                    item-value="id"
                    v-model="form.instance_user_id"
                />
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex xs12 sm9>
            <v-card>
              <v-card-text>
                <v-layout row wrap>
                  <v-flex xs12>
                    <div class='sl_form_title'>
                      <h3>Article text</h3>
                    </div>
                    <v-divider class='my-2'></v-divider>
                    <markdown
                        :editing="true"
                        label="Article text"
                        v-model="form.text"
                    />
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-tab-item>
      <v-tab-item>
        <v-layout row wrap>
          <v-flex xs12 sm4>
            <v-card>
              <v-card-text>
                <div class='sl_form_title'>
                  <h3>Accesses</h3>
                </div>
                <v-divider class='my-2'></v-divider>
                <sl-extended-select v-model="form.instance_users" :data="instance_users" :withOptions="true"></sl-extended-select>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-tab-item>
    </v-tabs-items>
  </v-container>
</template>

<script>
  import * as mixins from '@/mixins'
  import markdown from '@/components/markdown'
  import users from '@/components/sl-extended-select'

  export default {
    name: 'ArticlesFormPage',
    mixins: [mixins.errors, mixins.form, mixins.preloader, mixins.user],
    data() {
      return {
        api: this.$api.articles,
        tabs: null,
        instance_users: [],
        spaces: [],
        articles: [],
        form: {
          name: '',
          parent_id: 0,
          instance_user_id: 0,
          space_id: this.$route.params.space_id,
          text: '',
          instance_users: [],
        }
      }
    },
    methods: {
      getUsers() {
        return this.$api.spaces.get(this.$route.params.space_id).then(({data}) => {
          let instance_users = data.instance_users
            .map(item => ({...item, pivot: {edit: item.pivot.edit, delete: item.pivot.delete}}))
            .concat([{...data.instance_user, pivot: {edit: 1, delete: 1,}}])

          this.instance_users = instance_users
          if (this.$route.params.article_id == 0) {
            this.form.instance_users = instance_users
          }
        })
      },
      getArticles() {
        let params = {
          space_id: parseInt(this.$route.params.space_id),
          unlimit: 1
        }
        return this.api.list(params).then(({data}) => {
          this.articles = data.filter(item => this.$route.params.article_id != item.id)
          if (this.$route.params.article_id == 0) {
            this.form.parent_id = parseInt(this.$route.query.parent_id || 0)
          }
        })
      },
      onMounted() {
        if (this.$route.params.article_id > 0) {
          this.load(this.$route.params.article_id)
        }

        this.form.instance_user_id = this.user.instanceUserIds[0]

        this.background(this.getArticles())
        this.background(this.getUsers())
      }
    },
    watch: {
      '$route.params.article_id'() {
        this.onMounted()
      }
    },
    mounted() {
      this.onMounted()
    },
    components: {
      'markdown': markdown,
      'sl-extended-select': users,
    },
  }
</script>

<style>
  .mark_down__textarea {
    width: 100%;
    border: 1px solid #ccc;
    padding: 10px;
    height: 100%;
    resize: none;
  }
</style>
